import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import {
  applicationFromEnvelope,
  checklistStepCodeFromPath,
  getOnboardingApplication,
} from './onboardingApi.js';
import {
  businessDetailsPath,
  getStoredResumeToken,
  useApplicationIdParam,
} from './onboardingState.js';

/**
 * Pre-tenant merchants can only use the checklist and business details.
 * Later screens 403 (verification.read, payout, terms) until the business exists.
 */
export function OnboardingLinearGate() {
  const location = useLocation();
  const applicationId = useApplicationIdParam();
  const resumeToken = getStoredResumeToken();
  const stepCode = checklistStepCodeFromPath(location.pathname);
  const applicationQuery = useQuery({
    queryKey: ['onboarding', applicationId, 'application'],
    queryFn: () => getOnboardingApplication(applicationId!, resumeToken),
    enabled: Boolean(applicationId),
  });
  const application = applicationFromEnvelope(applicationQuery.data);
  const preTenant = Boolean(applicationId) && !application?.businessId;
  const onChecklist = location.pathname === '/onboarding-checklist';

  if (onChecklist || !stepCode || stepCode === 'business-details') {
    return <Outlet />;
  }

  if (applicationId && applicationQuery.isLoading) {
    return null;
  }

  if (preTenant) {
    return <Navigate to={businessDetailsPath(applicationId ?? undefined)} replace />;
  }

  return <Outlet />;
}
